module.exports = __webpack_public_path__ + "static/media/intro-course.f480216a.png";